import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import Question from '../Question';
import { Button } from 'ncoded-component-library';
import ArrowleftIcon from 'icons/Arrowleft.icon';
import { useForm } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import ProgressBar from 'components/ProgressBar';
import useQuestions from '../../hooks/useQuestions';

import './MobileVendor.styles.scss';
import './MobileVendor.styles.responsive.scss';

type MobileVendorProps = {
  className?: string;
};

const MobileVendor: React.FC<MobileVendorProps> = (props) => {
  const { className } = props;

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const { t } = useTranslation();
  const { allQuestions: questions } = useQuestions();
  const { submit, getState } = useForm();

  const { submitting, invalid } = getState();

  const percentage = useMemo(
    () => (100 / questions.length) * (currentQuestion + 1),
    [currentQuestion, questions.length],
  );

  const RenderQuestion = useMemo(() => {
    const question = questions[currentQuestion];
    const Component = question.Component;

    return (
      <Question
        title={question.title}
        description={question.description}
        currentQuestionNum={currentQuestion + 1}
        numOfQuestions={questions.length}
        customQuestioLabel={question.customQuestioLabel}
      >
        <Component />
      </Question>
    );
  }, [currentQuestion, questions]);

  const classes = classNames('mobile-vendor', className);

  return (
    <div className={classes}>
      <ProgressBar percentage={percentage} />
      {RenderQuestion}
      <div className="mobile-vendor__actions">
        {currentQuestion > 0 && currentQuestion < questions.length - 1 && (
          <Button
            icon={ArrowleftIcon}
            variant="outline"
            onClick={() => {
              setCurrentQuestion((prev) => prev - 1);
            }}
          />
        )}
        <Button
          disabled={invalid || submitting}
          className={currentQuestion === questions.length - 1 ? 'submit' : ''}
          onClick={() => {
            if (currentQuestion === questions.length - 1) {
              submit();
            } else {
              setCurrentQuestion((prev) => prev + 1);
            }
          }}
        >
          {currentQuestion < questions.length - 2
            ? t('next')
            : currentQuestion === questions.length - 2
            ? t('finishUp')
            : t('submitVendorEnquiry')}
        </Button>
      </div>
    </div>
  );
};

export default MobileVendor;
